export const FORKHIRE_PRE_SHORTLIST_STAGES = ['applied', 'ai_reviewed'] as const;

export function isForkHireCandidateDetailUnlocked(stage: string | null | undefined) {
  if (!stage) return false;
  return !FORKHIRE_PRE_SHORTLIST_STAGES.includes(stage as typeof FORKHIRE_PRE_SHORTLIST_STAGES[number]);
}
